import { connect } from 'react-redux'
import { redirect } from 'redux-first-router'

import { SETTINGS_INTEGRATIONS_PAGE } from 'subapps/settings/types'
import { selectLocationKind } from 'selectors/location'
import { selectDidError } from 'ducks/integrations'
import { selectCanUseProductFeature } from 'ducks/billing/selectors/features'
import { INBOX } from 'ducks/billing/productTypes'
import { FEATURE_INBOX_PREMIUM_INTEGRATIONS } from 'ducks/billing/featureTypes'

import SettingsModal from './view'

function select(state) {
  return {
    animateModal: selectLocationKind(state) !== 'load',
    error: selectDidError(state),
    showPlanLimitation: !selectCanUseProductFeature(
      state,
      INBOX,
      FEATURE_INBOX_PREMIUM_INTEGRATIONS
    ),
  }
}

const perform = dispatch => {
  return {
    onClose: function doCloseModal() {
      dispatch(redirect({ type: SETTINGS_INTEGRATIONS_PAGE }))
    },
  }
}

export default connect(select, perform)(SettingsModal)
